import { useState } from "react"
import { Paper, Typography, Button } from "@mui/material"
import { List } from "lucide-react"

export const ListMessage = ({
  body,
  timestamp,
  links = [],
  action = {
    button: "Elige aqui",
    sections: [
      {
        title: "Servicios",
        rows: [
          {
            id: "defensa-laboral",
            title: "Defensa Laboral",
            description: null,
          },
        ],
      },
    ],
  },
  onSelect,
  onOpenModal,
}) => {
  const [modalOpen, setModalOpen] = useState(false)

  // Formatear el timestamp para mostrar solo la hora
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { 
      hour: "2-digit", 
      minute: "2-digit", 
      hour12: true 
    });
  };

  // Reemplazar URLs con enlaces y texto en negrita
  const renderFormattedText = (text) => {
    if (!text) return "";

    // Primero reemplazar texto en negrita (entre asteriscos)
    let result = text.replace(/\*(.*?)\*/g, "<strong>$1</strong>")

    // Luego reemplazar enlaces si existen
    if (links && links.length > 0) {
      links.forEach((link) => {
        result = result.replace(
          link.text,
          `<a href="${link.url}" style="color: #0078FF; text-decoration: none; font-weight: 500;">${link.text}</a>`,
        )
      })
    }

    return <div dangerouslySetInnerHTML={{ __html: result }} />
  }

  // Preparar las opciones para el modal
  const prepareOptions = () => {
    const options = []

    if (action && action.sections) {
      action.sections.forEach((section) => {
        if (section.rows) {
          section.rows.forEach((row) => {
            options.push({
              id: row.id,
              title: row.title,
              description: row.description,
            })
          })
        }
      })
    }

    return options
  }

  const handleOpenModal = () => {
    const options = prepareOptions();
    const title = action?.button || "Elige aquí";
    onOpenModal(title, options);
  }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "8px" }}>
        <Paper
          elevation={0}
          style={{
            backgroundColor: "#d9fdd3",
            padding: "8px 0px",
            borderRadius: "8px 8px 8px 8px",
            maxWidth: "80%",
            overflowWrap: "break-word",
            wordWrap: "break-word",
            wordBreak: "break-word",
            whiteSpace: "pre-wrap",
            boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
          }}
        >
          <Typography variant="body1" style={{marginBottom: "8px", padding:"0px 12px"}}>{renderFormattedText(body)}</Typography>

          <Typography
            variant="caption"
            style={{
              display: "block",
              textAlign: "right",
              marginTop: "4px",
              color: "#8696a0",
              padding:"0px 12px",
              fontSize: "11px",
            }}
          >
            {timestamp ? formatTime(timestamp) : ""}
          </Typography>

          <div
            style={{
              borderTop: "1px solid #ccc",
            }}
          >
            <Button
              variant="text"
              style={{
                color: "#008069",
                textTransform: "none",
                justifyContent: "center",
                width: "100%",
                padding: "8px 0",
                fontWeight: "500",
                fontSize: "14px",
              }}
              startIcon={<List size={18} color="#008069" />}
              onClick={handleOpenModal}
            >
              {action?.button || "Elige aquí"}
            </Button>
          </div>

        </Paper>
      </div>

      
    </>
  )
}

export default ListMessage

